import BaseCommand from "@/models/api/commands/BaseCommand";
import { CONTRACTOR_TYPES } from "@/static/contractorTypes";

export interface AttributeFromContractor {
  ContractorType: CONTRACTOR_TYPES;
  IsSelected: boolean;
}

export class ChangeAttributesFromPayerCommand extends BaseCommand {
  CommandName = "SetAttributesFromCustomContractor";
  Command: AttributeFromContractor;

  constructor(sessionId: string, operationId: string, command: AttributeFromContractor) {
    super(sessionId, operationId);
    this.Command = command;
  }
}
